import styled from 'styled-components';
import { media } from '@minecraft.themes';
import Icon from '@minecraft.icon';
import { Link } from 'react-router-dom';
import { Container } from 'components/styles/Shared';

export const StyledHeader = styled.header`
  display: flex;
  background: ${(props): string => props.theme.colors.primary.white};
  border-bottom: 1px solid ${(props): string => props.theme.colors.primary.ltGrey1};
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;

  ${media.md`
    position: relative;
  `}
`;

export const StyledContainer = styled(Container)`
  padding: 0.875rem 1rem 0.75rem;
  display: flex;
  max-width: none;

  ${media.md`
    padding: 0.75rem 1.875rem;
  `}
`;

export const StyledLogoutHeader = styled(StyledHeader)`
  background: ${(props): string => props.theme.colors.primary.dkBlue1};
`;

export const StyledLogo = styled.img`
  width: 9.1875rem;
`;

export const HomeLink = styled(Link)`
  display: none;
  ${media.md`
    display: block;
  `}
`;

export const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const UserItem = styled.div`
  font-size: 0.875rem;
  padding-right: 0.8rem;
  margin-right: 0.8rem;
  line-height: normal;
  position: relative;
  display: none;

  &:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 70%;
    width: 1px;
    background: ${(props): string => props.theme.colors.primary.darkGrey};
  }

  ${media.md`
      display: block;
  `}
`;

export const Logout = styled.a`
  line-height: normal;
  color: ${(props): string => props.theme.colors.primary.darkGrey} !important;

  &:active,
  &:hover {
    color: ${(props): string => props.theme.colors.primary.darkGrey} !important;
  }

  ${media.md`
    color: ${(props): string => props.theme.colors.primary.primary} !important;
    &:active,
    &:hover {
      color: ${(props): string => props.theme.colors.primary.primary} !important;
    }

    &:not([href]) {
      text-decoration: 'underline';
    }
  `}
`;

export const Nav = styled.div<{ $open: boolean }>`
  width: 100%;
  position: fixed;
  top: 3.1875rem;
  right: 0;
  width: 100%;
  bottom: 0;
  padding: 2rem 1rem;
  background: ${(props): string => props.theme.colors.primary.white};
  transition: 0.1s;
  opacity: ${(props): number => (props.$open ? 1 : 0)};
  z-index: ${(props): number => (props.$open ? 1 : -1)};
  height: ${(props): number => (props.$open ? 'auto' : 0)};
  ${media.md`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    position: static;
    opacity: 1;
    z-index: 1;
    height: auto;
  `}
`;

export const MenuIcon = styled(Icon)`
  margin-left: auto;
  ${media.md`
      display: none;
  `}
`;
